import template from './projects.html';
import controller from './projects.controller';

let projectsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default projectsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/projects/projects.component.js